import DefaultApiService from "./default";

const ContractorCostQuotesApi = {
  getMyCostQuotes: async () => {
    const res = await DefaultApiService.getCustomeApi(
      "SLN/Contractor/ContractorCostQuotes/GetMyCostQuotes"
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: res?.data ?? res ?? [],
    };
  },

  getMyCostQuoteableRequests: async () => {
    const res = await DefaultApiService.getCustomeApi(
      "SLN/Contractor/ContractorCostQuotes/GetMyCostQuoteableRequests"
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: res?.data ?? res ?? [],
    };
  },

  createDraft: async (payload) => {
    const res = await DefaultApiService.postApi(
      "SLN/Contractor/ContractorCostQuotes/CreateDraftCostQuote",
      payload
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: res?.data,
    };
  },

  submitCostQuote: async (costQuoteId) => {
    const res = await DefaultApiService.postApi(
      "SLN/Contractor/ContractorCostQuotes/SubmitCostQuote",
      { costQuoteId }
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: res?.data,
    };
  },

  deleteDraftCostQuote: async (costQuoteId) => {
    const res = await DefaultApiService.postApi(
      "SLN/Contractor/ContractorCostQuotes/DeleteDraftCostQuote",
      { costQuoteId }
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
    };
  },

  createRevision: async (payload) => {
    const res = await DefaultApiService.postApi(
      "SLN/Contractor/ContractorCostQuotes/CreateRevisionCostQuote",
      payload
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: res?.data,
    };
  },

  getCostQuoteById: async (costQuoteId) => {
    const res = await DefaultApiService.getCustomeApi(
      `SLN/Contractor/ContractorCostQuotes/GetCostQuoteById?costQuoteId=${costQuoteId}`
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: res?.data,
    };
  },

  previewPackageEquipment: async (packageId) => {
    const res = await DefaultApiService.getCustomeApi(
      `SLN/Contractor/ContractorCostQuotes/PreviewPackageEquipment?packageId=${packageId}`
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: res?.data,
    };
  },

  getEquipmentSnapshot: async (snapshotId) => {
    const res = await DefaultApiService.getCustomeApi(
      `SLN/Contractor/ContractorCostQuotes/GetEquipmentSnapshot?snapshotId=${snapshotId}`
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: res?.data,
    };
  },

  getContractorPackages: async () => {
    const res = await DefaultApiService.getCustomeApi(
      "SLN/Contractor/PackageManagement/GetList"
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: res?.data ?? res ?? [],
    };
  },
};

export default ContractorCostQuotesApi;
